(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CustomTabs"] && !Shopify.designMode) return;
  try {
    
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab){
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // ─────────────────────────────────────────────
  // STICKY HEADER
  // ─────────────────────────────────────────────
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  try {
    if (!customElements.get('sticky-header')) {
      customElements.define('sticky-header', StickyHeader);
    }
  } catch (e) {
    console.warn("StickyHeader registration skipped: ", e);
  }

  // ─────────────────────────────────────────────
  // MOBILE CUSTOM MENU
  // ─────────────────────────────────────────────
  function initCustomMobileMenu() {
    var triggers = document.querySelectorAll('[data-mobile-nav-trigger]');
    var overlay = document.getElementById('custom-mobile-overlay');
    
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'custom-mobile-overlay';
      overlay.className = 'custom-mobile-overlay';
      document.body.appendChild(overlay);
    }

    function closeAllDropdowns() {
      document.querySelectorAll('[data-mobile-dropdown]').forEach(function(dd) {
        dd.style.display = 'none';
        dd.classList.remove('is-active');
      });
      
      document.querySelectorAll('[data-mobile-nav-item]').forEach(function(item) {
        item.classList.remove('is-open');
        var btn = item.querySelector('[data-mobile-nav-trigger]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    function openDropdown(trigger) {
      var item = trigger.closest('[data-mobile-nav-item]');
      if (!item) return;
      
      var dropdown = item.querySelector('[data-mobile-dropdown]');
      if (!dropdown && trigger.mobileDropdown) {
        dropdown = trigger.mobileDropdown;
      }
      
      if (!dropdown) return;
      
      trigger.mobileDropdown = dropdown;
      
      closeAllDropdowns();
      
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      
      var menu = document.querySelector('.custom-mobile-menu');
      
      if (dropdown.parentElement !== document.body) {
        document.body.appendChild(dropdown);
      }
      
      var menuRect = menu.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var topVal = menuRect.bottom + scrollTop;
      
      dropdown.style.display = 'block';
      dropdown.style.position = 'absolute';
      dropdown.style.left = '1.6rem';
      dropdown.style.right = '1.6rem';
      dropdown.style.width = 'calc(100vw - 3.2rem)';
      dropdown.style.top = (topVal + 12) + 'px'; 
      dropdown.classList.add('is-active');
      
      if (overlay) {
        overlay.classList.add('is-visible');
      }
      
      document.body.style.overflow = 'hidden';
    }

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var item = this.closest('[data-mobile-nav-item]');
        if (!item) return;
        
        var dropdown = item.querySelector('[data-mobile-dropdown]');
        if (!dropdown && this.mobileDropdown) {
          dropdown = this.mobileDropdown;
        }
        
        if (dropdown && !this.mobileDropdown) {
          this.mobileDropdown = dropdown;
        }
        
        if (!dropdown) {
          var url = this.getAttribute('data-url') || '#';
          if (url && url !== '#') {
            window.location.href = url;
          }
          return;
        }
        
        var isOpen = item.classList.contains('is-open');
        if (isOpen) {
          closeAllDropdowns();
        } else {
          openDropdown(this);
        }
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function() {
        closeAllDropdowns();
      });
    }

    document.addEventListener('click', function(e) {
      var target = e.target;
      var isInsideMenu = target.closest('.custom-mobile-menu');
      var isInsideDropdown = target.closest('[data-mobile-dropdown]');
      var isOverlay = target.closest('.custom-mobile-overlay');
      
      if (!isInsideMenu && !isInsideDropdown && !isOverlay) {
        closeAllDropdowns();
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var openItem = document.querySelector('[data-mobile-nav-item].is-open');
        if (openItem) {
          var trigger = openItem.querySelector('[data-mobile-nav-trigger]');
          if (trigger) {
            openDropdown(trigger);
          }
        }
        if (window.innerWidth >= 990) {
          closeAllDropdowns();
        }
      }, 200);
    });
  }

  // ─────────────────────────────────────────────
  // PREDICTIVE SEARCH
  // ─────────────────────────────────────────────
  function initPredictiveSearch() {}

  // ─────────────────────────────────────────────
  // MOBILE SEARCH OVERLAY TOGGLE
  // ─────────────────────────────────────────────
  function initMobileSearchToggle() {
    var trigger = document.getElementById('mobile-search-trigger');
    var closeBtn = document.getElementById('mobile-search-close');
    var wrapper = document.querySelector('.header-wrapper');
    var input = document.querySelector('.header__search-input');
    var resultsWrapper = document.querySelector('.header__search-results-wrapper');

    if (!trigger || !wrapper) return;

    function closeMobileSearch(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      wrapper.classList.remove('mobile-search-open');
      document.body.style.overflow = '';
      if (input) {
        input.value = '';
        input.blur();
      }
      if (resultsWrapper) {
        resultsWrapper.style.display = 'none';
        resultsWrapper.innerHTML = '';
      }
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      wrapper.classList.add('mobile-search-open');
      document.body.style.overflow = 'hidden';
      
      if (input) {
        setTimeout(function() {
          input.focus();
          input.select();
        }, 350);
      }
      
      if (resultsWrapper) {
        resultsWrapper.style.display = 'none';
        resultsWrapper.innerHTML = '';
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        closeMobileSearch(e);
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && wrapper.classList.contains('mobile-search-open')) {
        closeMobileSearch(e);
      }
    });

    document.addEventListener('click', function(e) {
      if (wrapper.classList.contains('mobile-search-open')) {
        var searchForm = wrapper.querySelector('.header__search-form');
        if (searchForm && !searchForm.contains(e.target) && !e.target.closest('#mobile-search-trigger')) {
          closeMobileSearch(e);
        }
      }
    });
  }

  // ─────────────────────────────────────────────
  // DESKTOP MEGA MENU
  // ─────────────────────────────────────────────
  function initDesktopMegaMenu() {
    var items = document.querySelectorAll('.custom-mega-nav__item');
    if (!items.length) return;

    items.forEach(function(item) {
      var trigger = item.querySelector('.custom-mega-nav__trigger');
      var dropdown = item.querySelector('.custom-mega-dropdown');

      if (!trigger || !dropdown) return;
    });
  }

  // ─────────────────────────────────────────────
  // SHOPIFY CUSTOMIZER EVENTS
  // ─────────────────────────────────────────────
  document.addEventListener('shopify:block:select', function(event) {
    var target = event.target;
    if (target && target.classList.contains('custom-mega-nav__item')) {
      target.classList.add('is-open');
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    var target = event.target;
    if (target && target.classList.contains('custom-mega-nav__item')) {
      target.classList.remove('is-open');
    }
  });

  // ─────────────────────────────────────────────
  // CHẶN ENTER TRÊN SEARCH
  // ─────────────────────────────────────────────
  // ─────────────────────────────────────────────
  // KHỞI TẠO TẤT CẢ
  // ─────────────────────────────────────────────
  function initAll() {
    initMobileSearchToggle();
    initCustomMobileMenu();
    initPredictiveSearch();
    initDesktopMegaMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function() {
    initAll();
  });

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      var openItem = document.querySelector('[data-mobile-nav-item].is-open');
      if (openItem) {
        var trigger = openItem.querySelector('[data-mobile-nav-trigger]');
        if (trigger) {
          var event = new Event('click');
          trigger.dispatchEvent(event);
        }
      }
      if (window.innerWidth >= 990) {
        var overlay = document.getElementById('custom-mobile-overlay');
        if (overlay) overlay.classList.remove('is-visible');
        document.body.style.overflow = '';
      }
    }, 200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nnom-home-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-panel]'));

      const activate = (id) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.tab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          const active = panel.dataset.panel === id;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          activate(tabs[nextIndex].dataset.tab);
        });
      });

      root.querySelectorAll('[data-panel]').forEach((panel) => {
        const rail = panel.querySelector('[data-rail]');
        const prev = panel.querySelector('[data-prev]');
        const next = panel.querySelector('[data-next]');
        if (!rail) return;

        const scroll = (direction) => {
          const card = rail.querySelector('.nhcs__product');
          const distance = card ? card.getBoundingClientRect().width + 14 : rail.clientWidth * .8;
          rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
        };

        prev?.addEventListener('click', () => scroll(-1));
        next?.addEventListener('click', () => scroll(1));
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (!root.contains(event.target)) return;
        const panel = event.target.closest('[data-panel]');
        if (panel) activate(panel.dataset.panel);
      });
    };

    document.querySelectorAll('.nhcs').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
